export function interpolate(template, params) {
    return new Function(...Object.keys(params), `return \`${template}\`;`)(...Object.values(params));
}
//# sourceMappingURL=interpolate.js.map